"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/sso");
const Actions = require("../../actions/sso");
const sok_types_1 = require("@caddigital/sok-types");
function list(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_LIST_REQUEST), (0, operators_1.mergeMap)((_request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/auth/sso`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.SSO.iSSO).decode(res.response);
        const act = validation.fold((e) => Actions.fetchListFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchListSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchListFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function verify(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.VERIFY_REQUEST), (0, operators_1.mergeMap)((action) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/auth/sso/${action.payload}`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = sok_types_1.SSO.iSSO.decode(res.response);
        const act = validation.fold((e) => Actions.verifyFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.verifySuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.verifyFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
// MANAGEMENT
function managementList(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_MANAGEMENT_LIST_REQUEST), (0, operators_1.mergeMap)((_request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/sso`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.SSO.iSSO).decode(res.response);
        const act = validation.fold((e) => Actions.fetchManagementListFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchManagementListSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchManagementListFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function managementCurrent(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_MANAGEMENT_CURRENT_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/auth/sso/${request.payload}`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = sok_types_1.SSO.iSSO.decode(res.response);
        const act = validation.fold((e) => Actions.fetchManagementCurrentFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchManagementCurrentSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchManagementCurrentFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function managementRemove(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.MANAGEMENT_REMOVE_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'DELETE',
        url: `${fetchOptions.baseUrl}api/sso/${request.payload.provider}`
    })
        .pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.managementRemoveSuccess(), Actions.fetchManagementListRequest())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.managementRemoveFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function managementCurrentSave(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SAVE_MANAGEMENT_CURRENT_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'PUT',
        body: request.payload.data,
        url: `${fetchOptions.baseUrl}api/sso/${request.payload.provider}`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = sok_types_1.SSO.iSSO.decode(res.response);
        const act = validation.fold((e) => Actions.saveManagementCurrentFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.saveManagementCurrentSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.saveManagementCurrentFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function managementClientList(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_MANAGEMENT_CLIENT_LIST_REQUEST), (0, operators_1.mergeMap)((_request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/sso/clients`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.SSO.iSSOClient).decode(res.response);
        const act = validation.fold((e) => Actions.fetchManagementClientListFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchManagementClientListSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchManagementClientListFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function managementCreateFederation(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_NEW_FEDERATION_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'POST',
        body: request.payload,
        url: `${fetchOptions.baseUrl}api/sso`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = sok_types_1.SSO.iSSO.decode(res.response);
        const act = validation.fold((e) => Actions.createNewFederationFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.createNewFederationSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.createNewFederationFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function managementCompanyList(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_MANAGEMENT_COMPANY_LIST_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/customer/provider/${request.payload}`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.Customer.iCustomer).decode(res.response);
        const act = validation.fold((e) => Actions.fetchManagementCompanyListFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchManagementCompanyListSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchManagementCompanyListFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function attachCompany(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.ATTACH_COMPANY_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'POST',
        body: request.payload.customer,
        url: `${fetchOptions.baseUrl}api/sso/${request.payload.sso.provider}/company`
    })
        .pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.attachCompanySuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.attachCompanyFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function detachCompany(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DETACH_COMPANY_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'DELETE',
        url: `${fetchOptions.baseUrl}api/sso/${request.payload.sso.provider}/company/${request.payload.customer.id}`
    })
        .pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.detachCompanySuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.detachCompanyFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function searchCompany(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SEARCH_COMPANIES_REQUEST), (0, operators_1.mergeMap)((request) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/customer/search/${request.payload}`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.Customer.iCustomer).decode(res.response);
        const act = validation.fold((e) => Actions.searchCompaniesFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.searchCompaniesSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.searchCompaniesFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function listUsers(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.LIST_USERS_REQUEST), (0, operators_1.mergeMap)((action) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'GET',
        url: `${fetchOptions.baseUrl}api/sso/${action.payload.sso.provider}/users?filter=${action.payload.filter}`
    })
        .pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.User.iUser).decode(res.response);
        const act = validation.fold((e) => Actions.listUsersFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.listUsersSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.listUsersFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function convertUsers(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CONVERT_USERS_REQUEST), (0, operators_1.mergeMap)((action) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'POST',
        body: action.payload.users,
        url: `${fetchOptions.baseUrl}api/admin/user/convert/sso/${action.payload.sso.id}`
    })
        .pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.convertUsersSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.convertUsersFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
function addDomain(action$, _store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.ADD_DOMAIN_REQUEST), (0, operators_1.mergeMap)((action) => fetchOptions
        .ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: fetchOptions.getToken()
        },
        method: 'POST',
        body: { domain: action.payload.domain },
        url: `${fetchOptions.baseUrl}api/sso/${action.payload.sso.provider}/domain`
    })
        .pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.addDomainSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.addDomainFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.allEpics = redux_observable_1.combineEpics(list, verify, managementList, managementRemove, managementCurrent, managementCurrentSave, managementClientList, managementCompanyList, managementCreateFederation, attachCompany, detachCompany, searchCompany, listUsers, convertUsers, addDomain);
//# sourceMappingURL=index.js.map